import styled from "styled-components";

export const StyledDefaultPage = styled.section`
width: 100vw;
background-color: #F9F9F9;
padding-top: 1rem;
padding-bottom: 0rem;
padding-left: 1rem;
padding-right: 1rem;

.searchBox  {
        width: 100% !important
    }

@media (max-width: 769px) {
    .timesheet-detalhes {
        flex: 0 0 auto !important;
        width: 100%  !important;
    }
}

.btn-group-vertical>.btn-check:checked+.btn, .btn-group-vertical>.btn-check:focus+.btn, .btn-group-vertical>.btn.active, .btn-group-vertical>.btn:active, .btn-group-vertical>.btn:focus, .btn-group-vertical>.btn:hover, .btn-group>.btn-check:checked+.btn, .btn-group>.btn-check:focus+.btn, .btn-group>.btn.active, .btn-group>.btn:active, .btn-group>.btn:focus, .btn-group>.btn:hover {
    z-index: 0 !important;
}

.prazo-error {
    color: #dc3545 !important;
}

.prazo-warning {
    color: #ffc107 !important;
}

.prazo-success {
    color: #28a745 !important;
}

.pendencia-de-aprovacao {
    text-align: center;
    .button-reprovar {
        background-color: transparent;
        border-color: #dc3545;
        color: #dc3545;

        &:hover {
            background-color: #dc3545;
            border-color: #dc3545;
            color: #fff;
        }
    }

    .button-resumo {
        background-color: transparent;
        border-color: #b5aeae;
        color: #b5aeae;

        &:hover {
            background-color: #b5aeae;
            border-color: #b5aeae;
            color: #fff;
        }
    }

    .button-aprovar {
        background-color: #28a745;
        border-color: #28a745;

        &:hover {
            background-color: #3fb35a;
            border-color: #28a745;
        }
    }

    .button-concluir {
        background-color: #007bff;
        border-color: #007bff;

        &:hover {
            background-color: #0d6efd;
            border-color: #0d6efd;
            color: #fff;
        }
    }
}

@media only screen and (min-width: 767px) and (max-width: 1280px) {
    width: calc(100% - 138px);
}


@media only screen and (min-width: 1360px) {
    width: calc(100% - 160px);
}

& h2 {
    margin-top: .25rem;
    margin-bottom: 1rem;
}

.title-row {
    display: flex;
    align-items: center;
    color: #2c3b82;
    font-weight: 1000;
}

.title-row-header {
    font-weight: 1000;
}

.default-button {
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: white;
    color: #EE4B21;
    font-size: 0.8rem;
}

.default-button-blue {
    max-width: 280px;
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #2c3b82;
    border-radius: 0.25rem;
    background-color: #2c3b82;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #1d254c;
        border: solid 1px #1d254c;
    }
    &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
}

.default-button-red {
    max-width: 280px;
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.default-button-red-small {
    max-width: 280px;
    min-width: 100px;
    padding: 0.20rem .25rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.77rem;
}


.default-button-red-block {
    width: 100%;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

@media only screen and (max-width: 768px) {
    .btn-remove-max-width {
     max-width: none;
    }
}

.cursorPointer:hover {
    cursor: pointer !important;
}

.default-button-alert {
    background: #EE4B21
}
@media only screen and (min-width: 768px) {
    .atividade-acoes {
        min-width: 540px;
    }
}



.card {
    background-color: #fff;
    padding: 1rem;
    border-radius: .25rem;
    min-width: 90%;
    margin-top: .25rem;

    & .border-wrapper {
        border: solid 1px #ccc;
        border-radius: .25rem;
        padding: 1rem;
    }

    & .filter-container {
        transition: .3s;
        height: auto;
    }

    & .filter-hide {
        height: 0;
        overflow: hidden;
        transition: .3s;
    }

    .react-tabs__tab-list { border-bottom: 0px solid #aaa; margin: 0 0 10px; padding: 0; }
    .react-tabs__tab { display: inline-block; border: 0px solid transparent; border-bottom: none; bottom: -1px; position: relative; list-style: none; padding: 6px 12px; cursor: pointer; }
    .react-tabs__tab--selected { border-bottom: 4px solid red; background: #fff; border-color: red; color: black; border-radius: 5px 5px 0 0; }
    .react-tabs__tab-panel { display: none; }
    .react-tabs__tab-panel--selected { display: block; }
    .react-tabs__tab--disabled { border-bottom: 1px solid gray; border-color: red; color: GrayText; cursor: default; }
    .react-tabs__tab:focus:after { content: ""; position: absolute; height: 5px; left: -4px; right: -4px; bottom: -5px; background: red; border-bottom: 1px solid #fff;}

}

.export-pdf {
    font-size: 10px;
    .top {
        width: 100%;
    }

    tr {
        th {
            background: #2c3b82;
            color: #fff;
        }
    }
}

.timesheet {
    border-radius: .25rem;
    min-width: 90%;
    min-height: 90%;
    margin-top: 1rem;

    & .border-wrapper {
        border: solid 1px #ccc;
        border-radius: .25rem;
        padding: 1rem;
    }

    & .filter-container {
        transition: .3s;
        height: auto;
    }

    & .filter-hide {
        height: 0;
        overflow: hidden;
        transition: .3s;
    }

    .react-tabs__tab-list { border-bottom: 0px solid #aaa; margin: 0 0 10px; padding: 0; }
    .react-tabs__tab { display: inline-block; border: 0px solid transparent; border-bottom: none; bottom: -1px; position: relative; list-style: none; padding: 6px 12px; cursor: pointer; }
    .react-tabs__tab--selected { border-bottom: 4px solid red; background: #fff; border-color: red; color: black; border-radius: 5px 5px 0 0; }
    .react-tabs__tab-panel { display: none; }
    .react-tabs__tab-panel--selected { display: block; }
    .react-tabs__tab--disabled { border-bottom: 1px solid gray; border-color: red; color: GrayText; cursor: default; }
    .react-tabs__tab:focus:after { content: ""; position: absolute; height: 5px; left: -4px; right: -4px; bottom: -5px; background: red; border-bottom: 1px solid #fff;}

    .title-row-info {
        display: flex;
        align-items: left;
        color: #2c3b82;
        font-weight: 1000;
    }

    .title-row-sub {
        display: flex;
        align-items: center;
        color: gray;
        font-weight: 1000;
    }

    .legend-info {
        color: gray;
        font-weight: 1000;
        font-size: 12px;
    }

    .legend-info-details {
       white-space: nowrap;
       font-size: 0.90rem;
    }

    .data-info {
        color: gray;
        // font-weight: 1000;
        font-size: 14px;
        padding: 0.3rem;
    }

    .data-info-valor {
        color: #2c3b82;
        font-weight: 1000;
        font-size: 14px;
    }

    .data-info-subtrai {
        color: #da7070 !important;
    }

    .data-info-legend {
        color: #2c3b82;
        font-weight: 1000;
        font-size: 14px;
        background: #E8E8E8;
        border-radius: 10px;
    }

    .data-info-sublinhado {
        font-weight: 1000;
        background: #E8E8E8;
        border-radius: 10px;
    }

    .grid-info {
        color: #2c3b82;
        font-weight: 1000;
        font-size: 14px;
        background: #E8E8E8;
    }

    .grid-legend-info-2 {
        color: red;
        font-weight: 1000;
        font-size: 14px;
    }

    .grid-legend-info-mobile2 {
        color: red;
        font-weight: 1000;
        font-size: 12px;
    }

    .grid-legend-info-1 {
        color: #2c3b82;
        font-weight: 1000;
        font-size: 14px;
    }

    .grid-legend-info-mobile1 {
        color: #2c3b82;
        font-weight: 1000;
        font-size: 12px;
    }

    .container-data {
        background: #E8E8E8;
    }

    .flex-column-8 {
        width: 25%;
    }

    .flex-column-9 {
        width: 5%;
    }

    .flex-column-1 {
        width: 40%;
    }

    .flex-column-2 {
        width: 15%;
    }

    .flex-column-3 {
        width: 15%;
    }

    .flex-column-12 {
        width: 30%;
    }

    .flex-column-center {
        width: 100%;
        text-align: center;
    }

    .flex-column-left {
        width: 100%;
        text-align: left;
    }

    .flex-column-right {
        width: 100%;
        text-align: right;
    }

    @media only screen and (max-width: 768px) {
        .flex-column-center-mobile {
            width: 100%;
            text-align: center !important;
        }
    }

    .column-right {
        text-align: right;
    }

    .flex-column-4 {
        width: 15%;
    }

    .flex-column-5 {
        width: 15%;
    }

    .flex-column-6 {
        width: 15%;
    }

    .flex-column-7 {
        width: 15%;
        text-align: right;
    }

    .flex-column-9 {
        width: 100%;
        text-align: center;
    }

    .flex-column-10 {
        width: 80%;
        text-align: right;
    }

    .flex-column-11 {
        width: 30%;
        text-align: right;
    }

    .flex-column-title {
        width: 100%;
    }
    .flex-column-data {
        text-align: right;
    }
    .table-scroll {
        overflow-x: scroll;
        overflow-y: hidden;
        width:100%;
        height:100%;
    }

    @media only screen and (max-width: 769px) {
        & .timesheet-infs {
            display: inline !important;
        }

        .flex-column-right {
            text-align: center;
        }

        .flex-column-1, .flex-column-2, .flex-column-3,
        .flex-column-4, .flex-column-5, .flex-column-6,
        .flex-column-7 {
            width: 50%;
            text-align: left;
        }

        .data-info {
            margin-bottom: 1px;
        }

        .timesheet-more-infs {
            flex-wrap: wrap;
        }
    }
}



.select-custom{
    font-size: 13px;
}

@media only screen and (max-width: 769px) {
    .select-custom{
        font-size: 12px;
    }

    .my-1-mobile {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .mt-1-mobile {
        margin-top: 1rem;

    }
    .mb-1-mobile {
        margin-top: 1rem;
    }

}

.revisaoCard{
    background: #f1626240 !important;
}

.esclarecimentoCard{
    background: #f3e8f3 !important;
}

.notificacaoCard{
    background: #f7cc4d61 !important;
}

.probonoCard {
    background: #cdeeff;
}


.text-revisaoCard{
    color: #f1626240 !important;
}

.text-notificacaoCard{
    color: #f7cc4d61 !important;
}


.filter-Reprovado{
    background: #f1626240 !important;
}

.filter-Notificado {
    background: #f7cc4d61 !important;
}

.filter-Esclarecimento {
    background: #f3e8f3 !important;
}


.cursor-pointer{
    cursor: pointer !important;
}

.color-text-filter{
    color: var(--bs-gray-900);
}


@keyframes fa-blink {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 0; }
}
.fa-blink {
  -webkit-animation: fa-blink .75s linear infinite;
  -moz-animation: fa-blink .75s linear infinite;
  -ms-animation: fa-blink .75s linear infinite;
  -o-animation: fa-blink .75s linear infinite;
  animation: fa-blink .75s linear infinite;
}

.searchWrapperPrecificacao input {
    padding: 8px;
}

 .searchWrapperCustom {
        input:not([type="checkbox"]) {
             min-height: 30.5px !important;
        }

    }

    .text-max-10{
        white-space: nowrap;
        max-width: 15ch;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .btn-light {
        --bs-btn-active-bg: #f0f0f0 !important;
    }

    .btn-group {
        padding: 0px 1.5px !important;
        border-radius: 0.5rem !important;
        border: 0.5px solid #ddd !important;

        .btn:Fist-child {
            border-radius: 0.5rem !important;
        }
        .btn:Fist-last {
            border-radius: 0.5rem !important;
        }
    }


    .text-max-50{
        white-space: nowrap;
        max-width: 50ch;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .text-max-3-lines{
        -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
    }

    .swal-wide{
        width: 80% !important;
    }





.font-0-5x {
  font-size: 0.5rem !important;
}

.font-0-6x {
  font-size: 0.6rem !important;
}

.font-0-7x {
  font-size: 0.7rem !important;
}

.font-0-8x {
  font-size: 0.8rem !important;
}

.font-0-9x {
  font-size: 0.9rem !important;
}


.font-1-0x {
  font-size: 1rem !important;
}

.font-1-1x {
  font-size: 1.1rem !important;
}

.font-1-2x {
  font-size: 1.2rem !important;
}

.font-1-3x {
  font-size: 1.3rem !important;
}

.font-1-4x {
  font-size: 1.4rem !important;
}

.font-1-5x {
  font-size: 1.5rem !important;
}

.font-1-6x {
  font-size: 1.6rem !important;
}

.font-1-7x {
  font-size: 1.7rem !important;
}

.font-1-8x {
  font-size: 1.8rem !important;
}

.font-1-9x {
  font-size: 1.9rem !important;
}

.font-2-1x {
  font-size: 2.1rem !important;
}

.font-2-2x {
  font-size: 2.2rem !important;
}

.font-2-3x {
  font-size: 2.3rem !important;
}

.font-2-4x {
  font-size: 2.4rem !important;
}

.font-2-5x {
  font-size: 2.5rem !important;
}

.font-2-6x {
  font-size: 2.6rem !important;
}

.font-2-7x {
  font-size: 2.7rem !important;
}

.font-2-8x {
  font-size: 2.8rem !important;
}

.font-2-9x {
  font-size: 2.9rem !important;
}

.font-3x {
  font-size: 3rem !important;
}

.font-4x {
  font-size: 4rem !important;
}

.font-5x {
  font-size: 4rem !important;
}

.bold{
    font-weight: 600;
}
    
.resposta-pendente {
    color: #ffc107 !important;
}

.color-change-icon {
  animation: color-change 0.3s ease-in-out infinite;
}

@keyframes color-change {
    0% {
        color: #f39c12;
    }
    50% {
        color: #e74c3c;
    }
    100% {
        color: #f3e8f3;
    }
}
`;
